import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { TownsFailure, TownsRequest, TownsSuccess } from './actions';
import { ParameterResult } from '@models/swagger';
import { TownsParams, TownsService } from './service';

@Injectable()
export class TownsEffects {
  private readonly actions$ = inject(Actions);
  private readonly townsService = inject(TownsService);

  towns$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TownsRequest),
      switchMap(({ parameters }: { parameters?: TownsParams }) =>
        this.townsService.towns(parameters).pipe(
          map((data: ParameterResult[]) => TownsSuccess({ data })),
          catchError(error => of(TownsFailure({ error })))
        )
      )
    )
  );

}
